// Al elegir una incidencia a mano en el formulario del Cuaderno, el destinatario y el equipo salen del contacto del ticket (lo
// resuelve el servidor contra la plantilla de ALM, por correo y si no por nombre: POST /agenda/destino-incidencia), igual que ya
// hace el cronometro al ligar una incidencia.
//
// Reglas, para no molestar:
//  · solo si el destinatario esta VACIO: lo escrito a mano manda siempre, y no se toca ni el equipo;
//  · si mientras llegaba la respuesta la persona ha escrito un destinatario o ha cambiado de incidencia, no se pisa nada;
//  · un contacto que no es usuario de ALM (un cliente de fuera) deja los campos como estan y se avisa en una linea;
//  · sin Odoo, o con un fallo, no se hace ni se dice nada: es una ayuda, no un paso obligatorio.
//
// Devuelve que paso, para poder probarlo: "rellenado" | "escrito" | "cambiado" | "no_reconocido" | "sin_odoo" | "error".
const vacio = v => !String(v ?? "").trim();

export async function rellenarDestinoDeIncidencia({ incidenciaId, actual, buscar, aplicar, avisar }) {
  const antes = actual();
  if (!antes || !vacio(antes.recipient)) return "escrito";
  let d;
  try { d = await buscar({ incidencia_id: incidenciaId }); } catch { return "error"; }
  if (!d || typeof d !== "object") return "error";
  if (d.motivo === "sin_odoo") return "sin_odoo";
  if (!d.reconocido || vacio(d.recipient)) {
    avisar?.("El contacto de esa incidencia no es usuario de ALM: indica el destinatario a mano.");
    return "no_reconocido";
  }
  const ahora = actual();
  if (!ahora || String(ahora.incidencia_id) !== String(incidenciaId) || !vacio(ahora.recipient)) return "cambiado";
  aplicar(d.department ? { recipient: d.recipient, department: d.department } : { recipient: d.recipient });
  return "rellenado";
}
